import parse from 'html-react-parser';

export const formatDescription = (desc) => {
    if (!desc) return null;

    const sanitized = sanitizeHtml(desc);

    try {
        return parse(sanitized);
    } catch (err) {
        return (
            <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>
            {desc}
            </pre>
        );
    }
};

const ALLOWED_TAGS = ['b', 'br', 'i', 'u', 'span', 'strong', 'em', 'p', 'div'];

const sanitizeHtml = (text) => {
    if (!text) return '';

    return text.replace(/<([^>\s\/]+)([^>]*)>/g, (match, tagName) => {
        if (!ALLOWED_TAGS.includes(tagName.toLowerCase())) {
            return match.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }
    return match;
    });
};

const toRad = (Value) => {
        return Value * Math.PI / 180
    }

export const calcCrow = (lat1, lon1, lat2, lon2) => {
    var R = 6371 // km
    var dLat = toRad(lat2 - lat1)
    var dLon = toRad(lon2 - lon1)
    var lat1 = toRad(lat1)
    var lat2 = toRad(lat2)

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    var d = R * c
    return d
}